export function getAttr(el, attr) {
  return el.getAttribute(attr);
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/getAttr.js
// module id = 842
// module chunks = 2